import React, { Component } from "react";
import {
    DataGrid,
    FilterRow,
    Editing,
    Column,
    Paging,
    Pager,
    FormItem,
    Lookup,
    StateStoring,
} from 'devextreme-react/data-grid';
import PaginaToolbar from '../../components/PaginaToolbar';
import { criarTextoCdaDs, criarReceitasDs } from "../../DataSources";
import UserInfo from "../../UserInfo";
import uiInfo from "../../ui-info";

const localStorageKey = "cadastroTextosCdaGridState";

let _textoCdaCorrente = undefined;

export default class TextoCdaBox extends Component {
    constructor() {
        super();
        this._gridInstance = React.createRef();
        this.onAtualizandoRow = this.onAtualizandoRow.bind(this);
    }

    onAtualizandoRow(e) {
        e.cancel = true;
        this.props.history.push("textoscda/editar/" + e.data.id);
    }

    render() {
        return (
            <div className={'content-block dx-card responsive-paddings'}>
                <PaginaToolbar titulo="Texto CDA" novoCb={this.novoTextoCda.bind(this)}>
                    <DataGrid
                        ref={grid => this._gridInstance = grid}
                        dataSource={criarTextoCdaDs()}
                        showBorders={true}
                        rowAlternationEnabled={true}
                        remoteOperations={true}
                        columnAutoWidth={true}
                        columnHidingEnabled={true}
                        focusedRowEnabled={true}
                        wordWrapEnabled={window.innerWidth < 800}
                        filterSyncEnabled={true}
                        onEditingStart={this.onAtualizandoRow}>
                        <StateStoring enabled={true} type={'localStorage'} storageKey={localStorageKey} />
                        <FilterRow visible={true} />
                        <Editing allowDeleting={true} allowUpdating={true} mode />
                        <Column dataField={'id'} caption={"#"} width={'50px'}/>
                        <Column dataField={'prefeituraId'} caption={"Prefeitura"} visible={false}>
                            <FormItem visible={false}></FormItem>
                        </Column>
                        <Column dataField={'receitaId'} caption={"Receita"} >
                            <Lookup
                                dataSource={criarReceitasDs}
                                valueExpr="id"
                                displayExpr="descricao"
                            />
                        </Column>
                        <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
                        <Pager
                            showPageSizeSelector={true}
                            allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
                        />
                    </DataGrid>
                </PaginaToolbar>
            </div>
        );
    }

    novoTextoCda() {
        let gridState = this._gridInstance.instance.state();
        localStorage.setItem(localStorageKey, JSON.stringify(gridState));
        this.props.history.push("textoscda/novo");
    }

}
